module.exports = __webpack_public_path__ + "img/sv14.14d073fd.svg";